import { $post } from '@/http'

export default {
  //用户登录
  login(params) {
    return $post('user/login', {...params})
  },

  //用户注册
  register(params) {
    return $post('v1/user/signup', {...params})
  },

  //获取验证码
  getCode(params) {
    return $post('v1/user/code', {...params})
  },

  //找回密码
  resetPassword(params) {
    return $post('v1/user/forgetpwd', {...params})
  },

  //获取用户信息，头像昵称等
  getUserInfo() {
    return $post('user/info')
  }
}